import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMachineMain ( props ) {

    return <BasicCrudScreenType noCreate noEdit noDelete noExcel id="MomSysUglMachineMain" table="MomSysUglMachineMain" view="MomSysZvwMachineMain" />

}

export default MomSysMachineMain;
